import List from './List';
import Detail from './Detail';
import DeleteModal from './DeleteModal';
import DeactivateModal from './DeactivateModal';

export default {
  install(Vue) {
    Vue.component('CrudList', List);
    Vue.component('CrudDetail', Detail);
    Vue.component('c-delete-modal', DeleteModal);
    Vue.component('c-deactivate-modal', DeactivateModal);
  },
};
